import { render, staticRenderFns } from "./AssistantHeader.vue?vue&type=template&id=11cc9b02&scoped=true"
import script from "./AssistantHeader.vue?vue&type=script&lang=ts"
export * from "./AssistantHeader.vue?vue&type=script&lang=ts"
import style0 from "./AssistantHeader.vue?vue&type=style&index=0&id=11cc9b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cc9b02",
  null
  
)

export default component.exports